import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useNavigate } from "react-router-dom";

const TableUsers = ({ users }) => {
    const navigate = useNavigate();

    return (
        <Box mt={2}>
            <Paper elevation={0}>
                <TableContainer component={Paper} elevation={0}>
                    <Table sx={{ minWidth: 650 }}>
                        <TableHead>
                            <TableRow>
                                {/* <TableCell>Id</TableCell> */}
                                <TableCell>Usuário</TableCell>
                                <TableCell>Email</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users.map((item) => (
                                <TableRow key={item.id}>
                                    {/* <TableCell>{item.id}</TableCell> */}
                                    <TableCell>{item.userName}</TableCell>
                                    <TableCell>{item.email}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    )
}
export default TableUsers;